<template>
  <div class="cross-border-banner">
    <div class="banner-content">
      <div
        class="banner-text"
        ref="bannerText"
        :class="{ 'slide-up': isVisible }"
      >
        <div class="small-title">CROSS BORDER CARD</div>
        <h1 class="main-title">
          Make cross-border travel<br />
          as enjoyable as a funfair
        </h1>
        <el-button class="customBtn" type="primary" round @click="goTo"
          >Go shopping</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const bannerText = ref(null);
const isVisible = ref(false);
let observer = null;

const observerOptions = {
  threshold: 0.2,
};
const goTo = () => {
  window.open("https://www.coupon.ae/", "_blank");
};
const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isVisible.value = true;
      // Reset animation when element is out of view
      observer.unobserve(entry.target);
      setTimeout(() => {
        observer.observe(entry.target);
      }, 100);
    } else {
      isVisible.value = false;
    }
  });
};

onMounted(() => {
  observer = new IntersectionObserver(handleIntersect, observerOptions);
  if (bannerText.value) {
    observer.observe(bannerText.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.cross-border-banner {
  width: 100%;
  height: 340px;
  background-image: url("@/assets/imgsnew/tow/image.svg");
  background-size: cover;
  background-position: center;
  position: relative;

  .customBtn {
    font-size: 14px;
    background: #071b8b;
    border: none;
    margin-top: 20px;
    border-radius: 50px;
    padding: 12px 30px;
    &:hover {
      background: #071b8b;
    }
  }

  .banner-content {
    position: relative;
    height: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 80px;
    display: flex;
    align-items: center;
  }

  .banner-text {
    color: #ffffff;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;

    &.slide-up {
      opacity: 1;
      transform: translateY(0);
    }

    .small-title {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 1px;
      margin-bottom: 16px;
    }

    .main-title {
      font-size: 40px;
      font-weight: 600;
      line-height: 1.2;
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    height: 280px;

    .banner-content {
      padding: 0 20px;
      justify-content: center;
      text-align: center;
    }

    .banner-text {
      max-width: 280px;
      margin: 0 auto;

      .small-title {
        display: none;
      }

      .main-title {
        font-size: 24px;
        br {
          display: none;
        }
      }
    }

    .customBtn {
      font-size: 14px;
      padding: 14px 32px;
      height: 48px;
      margin-top: 24px;
    }
  }

  @media (max-width: 375px) {
    height: 240px;

    .banner-text {
      max-width: 260px;

      .main-title {
        font-size: 20px;
      }
    }
  }
}
</style>
